import { useCallback } from 'react';
import { PatientCacheRef } from './usePatientService';

export const useGetPatient = (patientCache: PatientCacheRef) => {
    const getPatient = useCallback(
        (id: number): PatientType | undefined => {
            return patientCache.current[id];
        },
        [patientCache]
    );

    return getPatient;
};
